module.exports = __webpack_public_path__ + "static/camera.60daad4318bf0a077c80c10d0dcd1cca.svg";